<template>
  <header
    slot="content-header"
    class="navbar navbar-header navbar-header-fixed"
  >
    <div
      @click="closeLevel2()"
      class="container d-flex flex-row align-items-center justify-content-center"
    >
      <a @click.stop="showLevel2()" class="burger-menu d-lg-none">
        <feather type="menu" class="wd-30-f ht-30-f"></feather>
      </a>
      <div class="mg-l-10 d-none d-md-block d-sm-block tx-color-02">
        {{ lesson.name }}
        <div class="tx-12 tx-rubik">
          {{ lesson.percent.completedItemCount }}/{{ lesson.percent.itemCount }}
        </div>
        <!-- <div class="progress ht-15">
            <div class="progress-bar wd-25p" :style="`width: ${lesson.percent}%`" role="progressbar">{{lesson.percent}}%</div>
          </div> -->
      </div>
      <div class="navbar-right">
        <a
          @click.stop="closeLevel2()"
          class="burger-menu d-lg-none"
          v-if="$store.state.app.responsiveLayout.level2.show"
        >
          <feather type="arrow-right" class="wd-30-f ht-30-f"></feather>
        </a>
        <!-- <a @click="$emit('toggle-filling-sidebar')" class="burger-menu" v-if="$route.params.bot==117 || $route.params.bot==416">
            <feather :type="rightSideBar?'chevron-right':'chevron-left'" class="wd-30-f ht-30-f"></feather>
          </a> -->
        <a @click="$emit('toggle-team-chat')" class="burger-menu">
          <feather type="message-square" class="wd-30-f ht-30-f"></feather>
        </a>
        <a
          class="burger-menu"
          @click="$emit('on-back-to-course')"
          v-if="!($route.params.bot == 117 || $route.params.bot == 416)"
        >
          <feather type="x" class="wd-30-f ht-30-f"></feather>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    rightSideBar: {
      type: Boolean,
      default: () => false
    },
    navbarmode: {
      type: Number,
      default: () => 0
    },
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions([
      "resetResponsiveLayoutConfig",
      "handleLevel2ResponsiveLayoutConfig"
    ]),
    showLevel2() {
      this.handleLevel2ResponsiveLayoutConfig({
        document: document,
        className: "course-sidebar-show"
      });
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    }
  }
};
</script>

<style></style>
